
    <app-comment-list *ngIf='q.answer'
          [featureType]=qs.offering
          [cmntType]="'Dnote'"  [parentHdrId]=qs.chapter [parentDtlId]=q.id
          [commentsI]='q.cmntsData && q.cmntsData.Dnote?q.cmntsData.Dnote:""'> </app-comment-list>
  
    
  